"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SheetMusicSimpleCreationProps = void 0;

var _vue = require("vue");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _message = _interopRequireDefault(require("ant-design-vue/lib/message"));

var _spin = _interopRequireDefault(require("ant-design-vue/lib/spin"));

require("ant-design-vue/lib/spin/style/index.css");

var _lodash = _interopRequireDefault(require("lodash"));

var _draggable = _interopRequireDefault(require("../draggable"));

var _uesSheetMusicPlayerOptions = _interopRequireDefault(require("../hooks/uesSheetMusicPlayerOptions"));

var _useSheetMusicBusiness = _interopRequireDefault(require("../hooks/useSheetMusicBusiness"));

var _keyboard = _interopRequireWildcard(require("./config/keyboard"));

var _useKeyBoradAction = _interopRequireDefault(require("./hooks/useKeyBoradAction"));

var _usePlayer2 = _interopRequireDefault(require("./hooks/usePlayer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var sheetMusicSimpleCreationProps = {
  sheetMusicCreationEl: Object,
  song: Object,
  sheetOption: Object,
  disabled: Boolean,
  draggableOpt: Object,
  keyboardOpen: {
    type: Boolean,
    default: true
  },
  loadSheetMode: {
    type: String,
    default: 'svgStr'
  },
  svgApi: {
    type: String,
    default: 'https://devpcloud-pre-render-service.ecoach.evideo.tech/sheet-svg/render-data'
  }
};
exports.SheetMusicSimpleCreationProps = sheetMusicSimpleCreationProps;
var SheetMusicSimpleCreation = (0, _vue.defineComponent)({
  name: 'SheetMusicSimpleCreation',
  components: {
    Spin: _spin.default,
    Draggable: _draggable.default,
    Message: _message.default
  },
  props: sheetMusicSimpleCreationProps,
  emits: ['error', 'success', 'restConfirm', 'loading'],
  setup: function setup(props, ctx) {
    var _this = this;

    var _a;

    var _useSheetMusicPlayerO = (0, _uesSheetMusicPlayerOptions.default)(),
        _loadFluidsynthjsSoundFont = _useSheetMusicPlayerO.loadFluidsynthjsSoundFont;

    var _useSheetMusicBusines = (0, _useSheetMusicBusiness.default)(),
        sheetMusicRuntimeInit = _useSheetMusicBusines.sheetMusicRuntimeInit,
        loadSheetMusic = _useSheetMusicBusines.loadSheetMusic,
        loadSheetMusicBySvgStr = _useSheetMusicBusines.loadSheetMusicBySvgStr;

    var loading = (0, _vue.ref)(false);
    var isPlaying = (0, _vue.ref)(false);
    (0, _vue.watch)(isPlaying, function (newVal) {
      console.log('isPlaying', newVal);

      if (newVal) {
        setPlayKeyboardText('停止');
      } else {
        setPlayKeyboardText('播放');
      }
    });
    var sheetMusicEl = (0, _vue.ref)();
    var sheetMusicContainerEl = (0, _vue.ref)();
    var sheetMusicBusiness = (0, _vue.shallowRef)();
    var cursorItem = (0, _vue.ref)();
    var keyboardRef = (0, _vue.ref)();
    var keyboardObj = (0, _vue.reactive)(_keyboard.default);
    var lastKeyboard = keyboardObj.last();

    var pianoKey = _lodash.default.find(lastKeyboard, function (o) {
      return o.action === _keyboard.keybordActions.piano;
    });

    var doreKey = _lodash.default.find(lastKeyboard, function (o) {
      return o.action === _keyboard.keybordActions.dore;
    });

    var playKey = _lodash.default.find(lastKeyboard, function (o) {
      return o.action === _keyboard.keybordActions.play;
    });

    var keyboardOpen = (0, _vue.ref)(props.keyboardOpen);
    var keyboardMidiEnable = (0, _vue.ref)(!!props.song.midiEnable);
    var keyboardDoing = (0, _vue.ref)(false);
    var keyBoardDisabled = (0, _vue.ref)(props.disabled);
    var playParams = (0, _vue.reactive)({
      song: props.song || {},
      isBeat: false,
      isPreReadyTime: false,
      isNoVolume: false,
      isRhythm: false,
      keySignature: undefined,
      partInfo: [],
      speed: undefined,
      fullSheet: false,
      showLyrics: true,
      closeAreaSelection: false
    });

    var _usePlayer = (0, _usePlayer2.default)(),
        setPlayerTool = _usePlayer.setPlayerTool,
        start = _usePlayer.start,
        stop = _usePlayer.stop,
        openAreaSelectionPlay = _usePlayer.openAreaSelectionPlay,
        playerCallBack = _usePlayer.playerCallBack,
        setPlayMode = _usePlayer.setPlayMode;

    var playEvents = (0, _vue.ref)({
      ON_START: function ON_START(playerTool) {
        console.log('ON_START');
        isPlaying.value = true;
        playerTool.plugin.$highlight.enable();
        playerTool.plugin.$openAreaSelection.enable();
        playerTool.plugin.$midiANote.disable();
      },
      ON_STOP: function ON_STOP(playerTool) {
        console.log('ON_STOP');
        isPlaying.value = false;
        playerTool.plugin.$highlight.disable();
        playerTool.plugin.$openAreaSelection.clearSelected();
        playerTool.plugin.$openAreaSelection.disable();
        playerTool.plugin.$midiANote.enable();
      },
      ON_ERROR: function ON_ERROR() {
        console.error('ON_ERROR');
      },
      ON_FLUIDSYNTHJS_LOAD_STATE: function ON_FLUIDSYNTHJS_LOAD_STATE(_ref) {
        var state = _ref.state;
        console.log('ON_FLUIDSYNTHJS_LOAD_STATE', state);
      }
    }); // 加载Fluidsynthjs进度回调

    var loadFluidsynthjsProgress = function loadFluidsynthjsProgress(progress) {
      if (progress.percentage < 100) {
        loading.value = true;
        var tip = "\u6B63\u5728\u4E0B\u8F7D\u97F3\u8272\u5E93".concat(progress.percentage, "%");
        ctx.emit('loading', true, tip);
        console.log(tip);
      } else {
        console.log('音色库准备完成');
        loading.value = false;
        ctx.emit('loading', false);
      }
    };

    var businessOptions = _lodash.default.merge({}, {
      userOptions: {
        fontSize: 40,
        pageWidth: 1000,
        lyricsMargin: 2,
        showAuxItem: false
      },
      playerOptions: {
        playerToolType: 'Midi',
        playerType: 'fluidsynthjs',
        instrumentBaseUrl: 'https://music-score.ecoach.evideo.tech/',
        fluidsynthLibHost: process ? ((_a = process.env) === null || _a === void 0 ? void 0 : _a.VUE_APP_HOST) || '' : '',
        loadFluidsynthjsSoundFont: function loadFluidsynthjsSoundFont() {
          console.log('编创题===>loadFluidsynthjsSoundFont');
          return new Promise(function (resolve, reject) {
            _loadFluidsynthjsSoundFont(true).then(function (res) {
              return resolve(res);
            }).catch(reject);
          });
        },
        loadFluidsynthjsProgress: loadFluidsynthjsProgress
      },
      pluginOptions: {
        Highlight: {
          enable: true
        },
        MidiANote: {
          enable: keyboardMidiEnable.value
        },
        OpenAreaSelection: {
          enable: true,
          init: function init(plugin) {
            plugin.onReady(function (range) {
              return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
                var state;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return openAreaSelectionPlay(range, playParams);

                      case 2:
                        state = _context.sent;
                        console.log('OpenAreaSelection', state);
                        plugin.show();

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
            });
          }
        }
      },
      events: {
        ON_CURSOR_CHANGED: function ON_CURSOR_CHANGED(val) {
          cursorItem.value = val;
        }
      }
    }, props.sheetOption || {});

    (0, _vue.watch)(function () {
      return props.disabled;
    }, function (newVal) {
      return keyBoardDisabled.value = newVal;
    });

    var onKeyboardBack = function onKeyboardBack() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                keyboardOpen.value = !keyboardOpen.value;
                setTimeout(function () {
                  keyboardRef.value && keyboardRef.value.reset();
                }, 100);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    };

    var keyboardActions = (0, _useKeyBoradAction.default)(sheetMusicBusiness, ctx, cursorItem, keyBoardDisabled, keyboardObj);

    var onKeyboardClick = function onKeyboardClick(keyboard) {
      var action = keyboard.action,
          params = keyboard.params,
          _keyboard$lock = keyboard.lock,
          lock = _keyboard$lock === void 0 ? true : _keyboard$lock;

      if (props.disabled && action !== _keyboard.keybordActions.play) {
        return;
      }

      if (action !== _keyboard.keybordActions.play && isPlaying.value) {
        // 播放中点击其他按钮不进行操作
        _message.default.info('播放中不能操作曲谱', 1.5);

        return;
      }

      var fun = keyboardActions[action];

      if (!fun) {
        ctx.emit('error', '没有找到对应的按键功能');
        console.warn('没有找到对应的按键功能');
        return;
      } // dont need lock


      if (!lock) {
        keyboardDoing.value = true;
        fun.apply(keyboard, [params]).then(function () {
          keyboardDoing.value = false;
        });
        return;
      }

      if (keyboardDoing.value) {
        console.warn('还有按键正在执行中');
        return;
      } // 播放


      if (action === _keyboard.keybordActions.play) {
        if (isPlaying.value) {
          stop();
        } else {
          playParams.sheetInfo = sheetMusicBusiness.value.getSheetBasic() || {};
          console.log('速度', playParams.sheetInfo.speed);
          playParams.speed = playParams.sheetInfo.speed;
          playParams.keySignature = playParams.sheetInfo.keySignature;
          playParams.partInfo = playParams.sheetInfo.partInfo;
          start(playParams);
        }

        return;
      }

      if (action === _keyboard.keybordActions.piano) {
        setMode(0);
        return;
      } else if (action === _keyboard.keybordActions.dore) {
        setMode(1);
        return;
      } //* lock


      keyboardDoing.value = true;
      fun.apply(keyboard, [params]).then(function () {
        keyboardDoing.value = false;
      });
    };

    var setMode = function setMode(mode) {
      if (pianoKey && doreKey) {
        if (mode === 0) {
          pianoKey.class = 'action-btn-green';
          doreKey.class = 'action-btn';
        } else {
          doreKey.class = 'action-btn-green';
          pianoKey.class = 'action-btn';
        }
      }

      setPlayMode(mode);
    };

    var loadSheet = function loadSheet() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _b, _c, _d, _e, evxmlFileUrl;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading.value = true;
                ctx.emit('loading', true);

                if (!(!((_b = props.song) === null || _b === void 0 ? void 0 : _b.sheetFileUrl) && !((_c = props.song) === null || _c === void 0 ? void 0 : _c.answerFilePath))) {
                  _context3.next = 8;
                  break;
                }

                ctx.emit('error', '没有曲谱文件');
                console.error('没有曲谱文件');
                loading.value = false;
                ctx.emit('loading', false);
                return _context3.abrupt("return");

              case 8:
                evxmlFileUrl = ((_d = props.song) === null || _d === void 0 ? void 0 : _d.answerFilePath) || ((_e = props.song) === null || _e === void 0 ? void 0 : _e.sheetFileUrl);
                sheetMusicContainerEl.value = props.sheetMusicCreationEl || sheetMusicEl.value;
                businessOptions.userOptions.scaleCase = sheetMusicContainerEl.value.offsetWidth / 1920;

                if (!(props.loadSheetMode === 'common')) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 14;
                return loadSheetMusic(sheetMusicContainerEl.value, businessOptions, evxmlFileUrl);

              case 14:
                sheetMusicBusiness.value = _context3.sent;
                _context3.next = 21;
                break;

              case 17:
                if (!(props.loadSheetMode === 'svgStr')) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 20;
                return loadSheetMusicBySvgStr(sheetMusicContainerEl.value, businessOptions, evxmlFileUrl, props.svgApi);

              case 20:
                sheetMusicBusiness.value = _context3.sent;

              case 21:
                if (sheetMusicBusiness.value) {
                  _context3.next = 27;
                  break;
                }

                ctx.emit('error', '加载曲谱失败');
                console.warn('加载曲谱失败');
                loading.value = false;
                ctx.emit('loading', false);
                return _context3.abrupt("return");

              case 27:
                sheetMusicBusiness.value.plugin.$openAreaSelection.disable();

                if (!keyboardMidiEnable.value) {
                  _context3.next = 31;
                  break;
                }

                _context3.next = 31;
                return initPlayerTool();

              case 31:
                ctx.emit('success', '曲谱加载成功');
                console.info('曲谱加载成功');
                loading.value = false;
                ctx.emit('loading', false);

              case 35:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    };

    var initPlayerTool = function initPlayerTool() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return sheetMusicBusiness.value.initPlayerTool(playEvents.value);

              case 2:
                setPlayerTool(sheetMusicBusiness.value.playerTool);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    };

    var resetSheet = function resetSheet() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _f, evxmlFileUrl;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                loading.value = true;
                ctx.emit('loading', true);
                evxmlFileUrl = (_f = props.song) === null || _f === void 0 ? void 0 : _f.sheetFileUrl;
                sheetMusicBusiness.value.scaleTo(sheetMusicContainerEl.value.offsetWidth / 1920);
                _context5.prev = 4;
                _context5.next = 7;
                return sheetMusicBusiness.value.loadSheet(evxmlFileUrl);

              case 7:
                _context5.next = 16;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](4);
                ctx.emit('error', '加载曲谱失败');
                console.warn('加载曲谱失败');
                loading.value = false;
                ctx.emit('loading', false);
                return _context5.abrupt("return");

              case 16:
                loading.value = false;
                ctx.emit('loading', false);

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[4, 9]]);
      }));
    };

    var getSheet = function getSheet() {
      sheetMusicBusiness.value.editor.moveCursorTo(undefined); //* 清除红框高亮

      var name = sheetMusicBusiness.value.viewer.sheet.getTitle();
      var xml = sheetMusicBusiness.value.getSheetStr();
      var svg = sheetMusicContainerEl.value.getElementsByTagName('svg')[0].outerHTML;
      return {
        name: name,
        xml: xml,
        svg: svg
      };
    };

    var setPlayKeyboardText = function setPlayKeyboardText(text) {
      if (playKey) {
        playKey.text = text;
      }
    };

    var playCallBack = function playCallBack(res) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var _res$data$state, state;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!res.success) {
                  _context6.next = 4;
                  break;
                }

                _res$data$state = res.data.state, state = _res$data$state === void 0 ? 'finish' : _res$data$state;
                _context6.next = 4;
                return playerCallBack(state);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    };

    var parseJsBridgeResult = function parseJsBridgeResult(result) {
      var res = JSON.parse(result) || {};
      res.success = res.eventCode > 0;
      return (0, _extends2.default)({
        success: false,
        eventCode: 0,
        data: null
      }, res);
    };

    var setCallBackEvent = function setCallBackEvent(data) {
      var res = parseJsBridgeResult(data) || {};
      playCallBack(res);
    };

    (0, _vue.onMounted)(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var jsBridge;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('参数props.song', props.song);
                console.log('参数keyboardMidiEnable', keyboardMidiEnable.value);
                _context7.next = 4;
                return (0, _vue.nextTick)();

              case 4:
                _context7.prev = 4;
                _context7.next = 7;
                return sheetMusicRuntimeInit();

              case 7:
                _context7.next = 14;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](4);
                loading.value = false;
                ctx.emit('error', _context7.t0);
                return _context7.abrupt("return");

              case 14:
                if (window.WebViewJavascriptBridge) {
                  console.log('已进入安卓环境');
                  jsBridge = window.WebViewJavascriptBridge;
                  jsBridge.registerHandler('setCallBackEvent', setCallBackEvent);
                  businessOptions.playerOptions.playerType = 'fluidsynth';
                }

                _context7.next = 17;
                return loadSheet();

              case 17:
                setPlayKeyboardText('播放');
                console.log('初始化成功了');

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[4, 9]]);
      }));
    });
    (0, _vue.onBeforeUnmount)(function () {
      var _a, _b, _c;

      if (sheetMusicBusiness.value) {
        (_b = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.playerTool) === null || _b === void 0 ? void 0 : _b.destroyed();
        (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.destroyed();
      }
    });
    return {
      loading: loading,
      loadSheet: loadSheet,
      resetSheet: resetSheet,
      keyboardRef: keyboardRef,
      keyboardObj: keyboardObj,
      keyboardOpen: keyboardOpen,
      keyboardMidiEnable: keyboardMidiEnable,
      onKeyboardBack: onKeyboardBack,
      onKeyboardClick: onKeyboardClick,
      getSheet: getSheet
    };
  },
  render: function render() {
    var _this2 = this;

    return (0, _vue.createVNode)(_vue.Fragment, null, [(0, _vue.createVNode)(_draggable.default, (0, _objectSpread2.default)({
      "class": "simple-creation-keyboard-container",
      "ref": "keyboardRef"
    }, this.draggableOpt || {}), {
      default: function _default() {
        return [(0, _vue.createVNode)("div", {
          "class": "createion-keyboard"
        }, [_this2.keyboardOpen ? (0, _vue.createVNode)("div", {
          "class": "keyboard-content"
        }, [_this2.keyboardObj.map(function (row, index) {
          return (0, _vue.createVNode)("div", {
            "class": "content-line",
            "key": index
          }, [row.map(function (keyBoard, aIndex) {
            return (keyBoard.action !== _keyboard.keybordActions.play && keyBoard.action !== _keyboard.keybordActions.piano && keyBoard.action !== _keyboard.keybordActions.dore || _this2.keyboardMidiEnable) && (0, _vue.createVNode)("div", {
              "class": ['content-item', keyBoard.class],
              "key": keyBoard.text + aIndex,
              "onClick": function onClick() {
                return _this2.onKeyboardClick(keyBoard);
              }
            }, [keyBoard.text]);
          })]);
        })]) : '', (0, _vue.createVNode)("div", {
          "class": "keyboard-opera"
        }, [(0, _vue.createVNode)("div", {
          "class": "opera-icon move"
        }, null), (0, _vue.createVNode)("div", {
          "class": "opera-icon back",
          "onClick": _this2.onKeyboardBack
        }, null)])])];
      }
    })]);
  }
});

SheetMusicSimpleCreation.install = function (app) {
  app.component(SheetMusicSimpleCreation.name, SheetMusicSimpleCreation);
  return app;
};

var _default2 = SheetMusicSimpleCreation;
exports.default = _default2;